// Ratgeber-Artikel – zentral bearbeitbar. Jeder Artikel hat Abschnitte (sections) mit id/heading/paragraphs.
export const articles = [
  {
    slug: "was-kostet-eine-entruempelung",
    title: "Was kostet eine Entrümpelung?",
    metaTitle: "Was kostet eine Entrümpelung? | Ratgeber | Rümpeltaxi",
    metaDescription:
      "Was kostet eine Entrümpelung? Der Ratgeber von Rümpeltaxi erklärt die wichtigsten Kostenfaktoren und wie Sie ein nachvollziehbares Angebot erhalten.",
    excerpt:
      "Welche Faktoren den Preis einer Entrümpelung bestimmen – und wie Sie ein transparentes Angebot erhalten.",
    category: "Kosten",
    published: "2025-01-15",
    updated: "2025-01-15",
    readingTime: "6 Min.",
    sections: [
      {
        id: "einleitung",
        heading: "Warum es keinen Pauschalpreis gibt",
        paragraphs: [
          "Die Kosten einer Entrümpelung lassen sich nicht pauschal beziffern. Jedes Objekt ist unterschiedlich – in Größe, Füllgrad, Zugänglichkeit und Art der Gegenstände. Seriöse Anbieter nennen daher keinen Festpreis, bevor der Umfang geklärt ist.",
          "Ein nachvollziehbares Angebot entsteht erst, wenn klar ist, was geräumt werden soll, wie das Objekt erreichbar ist und welche Zusatzleistungen gewünscht sind.",
        ],
      },
      {
        id: "kostenfaktoren",
        heading: "Die wichtigsten Kostenfaktoren",
        paragraphs: [
          "Entscheidend sind vor allem die Menge und Art der Gegenstände, die Zugänglichkeit des Objekts, der Personal- und Zeitaufwand, die Transportwege sowie die Entsorgungskosten.",
          "Auch die Etage, das Vorhandensein eines Aufzugs und der Anteil an Sondermüll wirken sich auf den Aufwand aus. Verwertbare Gegenstände können den Aufwand in Einzelfällen verringern, eine pauschale Wertanrechnung ist jedoch nicht möglich.",
        ],
      },
      {
        id: "angebot",
        heading: "So entsteht ein transparentes Angebot",
        paragraphs: [
          "Zunächst schildern Sie Ihr Anliegen. Bilder oder eine Besichtigung helfen, den Umfang realistisch einzuschätzen. Auf dieser Grundlage erhalten Sie ein transparent aufgebautes Angebot für die vereinbarten Leistungen.",
          "So wissen Sie im Vorfeld, welche Leistungen enthalten sind und welche Zusatzleistungen gesondert vereinbart werden.",
        ],
      },
      {
        id: "sparen",
        heading: "Womit Sie Kosten beeinflussen können",
        paragraphs: [
          "Wenn Sie einzelne Gegenstände vorab selbst aussortieren oder verwertbare Dinge separat bereitstellen, kann sich der Aufwand verringern. Auch eine gute Zugänglichkeit und klare Absprachen wirken sich positiv aus.",
        ],
      },
    ],
    faq: [
      {
        q: "Ist ein Vor-Ort-Termin nötig?",
        a: "Bei kleineren Projekten reicht oft eine Beschreibung mit Bildern. Bei umfangreicheren oder schwer einschätzbaren Objekten ist eine Besichtigung sinnvoll.",
      },
    ],
    related: ["wie-laeuft-eine-haushaltsaufloesung-ab", "entruempelung-vor-immobilienverkauf"],
  },
  {
    slug: "wie-laeuft-eine-haushaltsaufloesung-ab",
    title: "Wie läuft eine Haushaltsauflösung ab?",
    metaTitle: "Wie läuft eine Haushaltsauflösung ab? | Ratgeber | Rümpeltaxi",
    metaDescription:
      "Ablauf einer Haushaltsauflösung: Von der ersten Kontaktaufnahme bis zur Übergabe. Der Ratgeber von Rümpeltaxi erklärt jeden Schritt.",
    excerpt:
      "Von der ersten Kontaktaufnahme bis zur Übergabe – so ist eine Haushaltsauflösung typischerweise strukturiert.",
    category: "Ablauf",
    published: "2025-01-20",
    updated: "2025-01-20",
    readingTime: "7 Min.",
    sections: [
      {
        id: "vorbereitung",
        heading: "Vorbereitung und Kontaktaufnahme",
        paragraphs: [
          "Am Anfang steht die Kontaktaufnahme. Sie schildern Ihr Anliegen und die wichtigsten Rahmenbedingungen: Um welches Objekt geht es, wie groß ist der Haushalt und bis wann soll die Auflösung abgeschlossen sein?",
          "Gerade in sensiblen Situationen – etwa nach einem Todesfall – ist ein respektvoller und diskreter Umgang besonders wichtig. Wünsche und Besonderheiten werden vorab besprochen.",
        ],
      },
      {
        id: "sichtung",
        heading: "Sichtung und Angebot",
        paragraphs: [
          "Auf Grundlage Ihrer Angaben, übermittelter Bilder oder einer Besichtigung verschaffen wir uns einen Überblick über Umfang und Aufwand. Anschließend erhalten Sie ein transparent aufgebautes Angebot.",
          "Wichtig ist, vorab zu klären, welche persönlichen Gegenstände gesichert und welche Dokumente aufbewahrt werden sollen.",
        ],
      },
      {
        id: "durchfuehrung",
        heading: "Durchführung",
        paragraphs: [
          "Nach der Beauftragung wird ein Termin abgestimmt. Am Einsatztag wird sortiert, abgebaut, abtransportiert und fachgerecht entsorgt. Verwertbares wird nach Möglichkeit getrennt.",
          "Auf Wunsch erfolgt eine besenreine Übergabe – das bedeutet in der Regel, dass die geräumten Flächen grob ausgekehrt werden.",
        ],
      },
      {
        id: "uebergabe",
        heading: "Übergabe",
        paragraphs: [
          "Zum Abschluss werden die vereinbarten Arbeiten gemeinsam geprüft und das Objekt entsprechend der Beauftragung übergeben. So haben Sie Sicherheit, dass alles wie besprochen erledigt wurde.",
        ],
      },
    ],
    faq: [
      {
        q: "Wie lange dauert eine Haushaltsauflösung?",
        a: "Das hängt vom Umfang, der Zugänglichkeit und dem Team ab. Kleinere Wohnungen sind oft an einem Tag geschafft, größere Objekte benötigen mehr Zeit.",
      },
    ],
    related: ["was-kostet-eine-entruempelung", "entruempelung-vor-immobilienverkauf"],
  },
  {
    slug: "entruempelung-vor-immobilienverkauf",
    title: "Entrümpelung vor einem Immobilienverkauf",
    metaTitle: "Entrümpelung vor dem Immobilienverkauf | Ratgeber | Rümpeltaxi",
    metaDescription:
      "Entrümpelung vor dem Immobilienverkauf: Wie eine geräumte Immobilie den Verkauf erleichtert. Der Ratgeber von Rümpeltaxi.",
    excerpt:
      "Warum eine geräumte, aufgeräumte Immobilie den Verkauf erleichtern kann – und worauf es dabei ankommt.",
    category: "Immobilien",
    published: "2025-01-25",
    updated: "2025-01-25",
    readingTime: "5 Min.",
    sections: [
      {
        id: "warum",
        heading: "Warum sich eine Räumung vor dem Verkauf lohnt",
        paragraphs: [
          "Eine leergeräumte Immobilie wirkt größer, heller und neutraler. Interessenten können sich Räume besser vorstellen, wenn sie nicht durch Möbel und persönliche Gegenstände abgelenkt werden.",
          "Für Fotos, Besichtigungen und die Übergabe an Käufer ist ein geräumtes Objekt in vielen Fällen von Vorteil.",
        ],
      },
      {
        id: "planung",
        heading: "Räumung sinnvoll planen",
        paragraphs: [
          "Klären Sie frühzeitig, was verkauft, gespendet, aufbewahrt oder entsorgt werden soll. Eine strukturierte Planung spart Zeit und vermeidet Stress kurz vor Besichtigungsterminen.",
          "Wenn mehrere Beteiligte – etwa eine Erbengemeinschaft – involviert sind, ist eine klare Abstimmung besonders hilfreich.",
        ],
      },
      {
        id: "uebergabe",
        heading: "Besenreine Übergabe",
        paragraphs: [
          "Viele Kaufverträge sehen eine besenreine Übergabe vor. Das bedeutet in der Regel, dass die vereinbarten Gegenstände entfernt und die Flächen grob ausgekehrt sind. Weitergehende Reinigung wird gesondert vereinbart.",
        ],
      },
    ],
    faq: [
      {
        q: "Sollte vor oder nach dem Verkauf geräumt werden?",
        a: "Das hängt von Ihrer Situation und den Vereinbarungen mit dem Käufer ab. Häufig erleichtert eine Räumung bereits vor den Besichtigungen den Verkaufsprozess.",
      },
    ],
    related: ["was-kostet-eine-entruempelung", "wie-laeuft-eine-haushaltsaufloesung-ab"],
  },
];

// Weitere geplante Ratgeberthemen (noch nicht ausgearbeitet)
export const plannedTopics = [
  "Haushaltsauflösung nach einem Todesfall",
  "Was bedeutet besenrein?",
  "Welche Gegenstände gelten als Sondermüll?",
  "Was geschieht mit verwertbaren Gegenständen?",
  "Entrümpelung bei einem Umzug ins Pflegeheim",
  "Keller richtig entrümpeln",
  "Dachboden richtig räumen",
  "Wie erkennt man eine seriöse Entrümpelungsfirma?",
  "Wohnungsauflösung nach einem Mieterwechsel",
  "Räumung von Gewerberäumen",
  "Vorbereitung auf eine Objektbesichtigung",
];

export const getArticle = (slug) => articles.find((a) => a.slug === slug);
